<mat-accordion>

    <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Ação - Atividade: {{oficina.descricao}}
            </mat-panel-title>
        </mat-expansion-panel-header>

        <cadastrar-acoes-turma #cadastrarAcoes [oficina]="oficina"
                         [perfilAcesso]="perfilAcesso">
        </cadastrar-acoes-turma>
    </mat-expansion-panel>


    <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="listarAcoes.carregarLista()"
                         (closed)="openFormCadastro = true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Lista de Ações ( {{ oficina.acoes?.length }} )
            </mat-panel-title>
        </mat-expansion-panel-header>

        <listar-acoes-turma #listarAcoes
                      [acoesAtividade]="oficina.acoes"
                      (onAtualizarAcao)="onGetAdicionar($event); cadastrarAcoes.atualizarAcao($event)"
                      (onAdicionar)="onGetAdicionar($event); cadastrarAcoes.cancelar()">
        </listar-acoes-turma>

    </mat-expansion-panel>


</mat-accordion>
